/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".button-disabled[_ngcontent-%COMP%]{opacity:.6;pointer-events:none;display:none}\n/*# sourceMappingURL=cust-subscription-details.component.css.map*/"];
export { styles as styles };
